import { lazyGetMessagePreviewSections } from 'owa-mail-ribbon-sections/lib/sections';
import type { MailboxInfo } from 'owa-client-types';

import { setMenuDefinition } from '../../mutatorActions/setMenuDefinition';

export const onMessagePreviewMenuClicked = (mailboxInfo: MailboxInfo): void => {
    lazyGetMessagePreviewSections.import().then(getMessagePreviewSections => {
        setMenuDefinition(
            'MessagePreviewMenuDefinitionStore',
            undefined /* projectionTabId */,
            () => {
                return {
                    sections: getMessagePreviewSections(mailboxInfo),
                };
            }
        );
    });
};
